module.exports = __webpack_public_path__ + "img/Onboarding2.564674b2.png";